import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, Channel, ChannelService } from 'lib-trend-core';
import { takeUntil } from 'rxjs';


@Component({
    selector: 'channel-redirect-messenger-component',
    templateUrl: 'channel-redirect-messenger.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChannelRedirectMessengerComponent extends AbstractComponent implements OnInit {

  constructor(
    public injector: Injector,
    public dialog: MatDialog,
    private channelService: ChannelService,
  ) {
    super(injector);
  }

  ngOnInit() {

    // A refused or cancelled authorization comes back on the query string, not the fragment —
    // without this branch the user is left on a blank redirect page with no way back.
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const reason = params['error_description'] ?? params['error'];
        if (!!reason) {
          this.alertService.error(reason);
          this.goBackToChannel(params['state']);
        }
      });

    this.route.fragment.subscribe(async fragment => {
      if (fragment) {
        const params = new URLSearchParams(fragment);
        const accessToken = params.get('access_token');
        // See the Instagram redirect: `state` is the channel being reconnected, when there is one.
        const idChannel = params.get('state') ?? undefined;
        this.channelService.createMessengerChannel(accessToken, idChannel).subscribe({
          next: (channels: Array<Channel>) => {
            this.alertService.success(!!idChannel
              ? this.t('channel.redirectMessenger.channelReconnectedSuccess')
              : this.t('channel.redirectMessenger.channelsCreatedSuccess'));
            this.goBackToChannel(idChannel);
          },
          error: (err) => {
            this.goBackToChannel(idChannel);
            this.alertService.error(err.error?.message ?? this.t('channel.redirectMessenger.channelsCreateError'));
          }
        });
      }
    });
  }

  /** Back to the reconnected channel when there is one, to the channel list otherwise. */
  private goBackToChannel(idChannel?: string): void {
    this.router.navigate(!!idChannel ? ['/channel/view', idChannel] : ['/channel']);
  }

}
